module.exports = __webpack_public_path__ + "img/concept-icon.6682aaf3.svg";